<template>
    <v-dialog v-model="dialogOpen" width="50%">

        <v-toolbar flat dense color="rgba(0,0,0,0.9)">
            <v-app-bar-nav-icon>
                <v-icon>mdi-information-outline</v-icon>
            </v-app-bar-nav-icon>

            <v-toolbar-title class="title ml-0 pl-2">
                Help
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn text
                   small
                   @click="editClicked"
                   :loading="loading">
                Contribute
            </v-btn>

            <v-btn icon text @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card class="pt-0" light>

            <v-card-text class="pt-5 markdown-editor">
                <vue-markdown :source="markdown" :show="true">
                </vue-markdown>
            </v-card-text>

        </v-card>

    </v-dialog>
</template>

<script>

import Store from '../store';
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import MaterialHeader from '../../../components/UI/MaterialHeader';
import Editor from '../MarkdownEditor';
import VueMarkdown from '@adapttive/vue-markdown';

const vuexModule = 'Help';

export default {

    components: {
        MaterialHeader,
        Editor,
        VueMarkdown
    },

    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        identifier: {
            type: String | null,
            required: true
        }
    },

    watch: {
        dialogOpen(value) {
            if (value) this.loadHelp();
        }
    },

    mounted() {
        if (this.value) this.loadHelp();
    },

    data() {
        return {
            markdown: '',
            newFile: false,
        }
    },
    computed: {

        ...mapState(vuexModule, [
            'loading'
        ]),

        ...mapGetters(vuexModule, []),

        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },

        contentLines() {
            const lines = this.markdown.split("\n");
            return lines.length;
        }
    },

    methods: {
        ...mapActions(vuexModule, [
            'getHelp'
        ]),

        ...mapMutations(vuexModule, []),

        editClicked() {
            const url = 'https://github.com/juhasev/sample-ninja-help/edit/master/' + this.identifier + '.md'
            this.sendToUrl(url, true);
        },

        closeDialog() {
            this.$emit('input', false);
        },

        loadHelp() {
            this.getHelp(this.identifier)
                .then(response => {
                    this.markdown = response.data.contents;
                })
                .catch(error => {
                    Bus.$emit('flash-message', {message: 'Help file (' + this.identifier +') failed to load!', type: 'error'});
                    console.error("Help file (" + this.identifier + ") failed to load with status (" + error.response.status + ")");
                    this.closeDialog();
                });
        },
    },

    created() {
        if (!this.$store.state[vuexModule]) {
            this.$store.registerModule(vuexModule, Store);
        }
    },
}

</script>
